import {Component, input, signal} from '@angular/core';
import {AuthService, OAuthState} from "../../services/auth/auth.service";

@Component({
  selector: 'homey-login-with-google-button',
  imports: [],
  standalone: true,
  templateUrl: './login-with-google-button.component.html',
})
export class LoginWithGoogleButtonComponent {
  public readonly oathState = input.required<OAuthState>();
  constructor(
    private readonly authService: AuthService,
  ) {
  }

  agreedToTerms = input.required<boolean>();
  loading = signal(false);

  async onLoginWithGoogle() {
    if (this.loading()) {
      return;
    }

    if (!this.agreedToTerms()) {
      alert('You must agree to the terms and conditions first');
      return;
    }
    this.loading.set(true);
    try {
      await this.authService.socialLogin(
        'google',
        this.oathState(),
      );
    } finally {
      this.loading.set(false);
    }
  }
}
